import tags from "../../../components/tags";
import { icons, img, note } from "../../../components/html";
import gRepresentation from "./client-credentials-grant.jpg";
import status from "../../../components/responses/statusTokens";

export default {
  "Client Credentials Grant": {
    post: {
      tags: [tags.accessTokens],
      summary: "Get token for administration tasks - Client Credentials Grant",
      description: `
      oauth/access-token
Get access to endpoints marked with ${icons.c}. 
Suitable for administration activities over SizeId for Business account. It complies with RFC 6749 4.4
      
## Graphical representation of token acquisition and communication with API 
${img(gRepresentation)}

${note(
  `Parameter \`client_secret\` must not be freely accessible. It serves as the access password to your API`
)}
`,
      requestBody: {
        required: true,
        content: {
          "application/json": {
            schema: {
              type: "object",
              properties: {
                grant_type: {
                  type: "string",
                  example: "client_credentials"
                },
                client_id: {
                  type: "string",
                  example: "CHANGE THIS"
                },
                client_secret: {
                  type: "string",
                  example: "CHANGE THIS"
                }
              }
            }
          }
        }
      },

      responses: {
        ...status,
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  token_type: {
                    type: "string",
                    example: "Bearer"
                  },
                  expires_in: {
                    type: "integer",
                    example: 3600
                  },
                  access_token: {
                    type: "string",
                    description: "Access token"
                  }
                }
              }
            }
          }
        }
      },
      security: []
    }
  }
};
